import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import logo from '../../../../assets/images/Informulate-20th-Anniversary-Logo.png';

export default function DesktopHeader() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [activeSection, setActiveSection] = useState('');
  const { pathname } = useLocation();
  const hashPrefix = pathname === '/' ? '' : '/';

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    // Sections to observe
    const sections = [
      { id: 'about', threshold: 0.2 },
      { id: 'service', threshold: 0.2 },
      { id: 'testimonial', threshold: 0.1 },
      { id: 'testimonial-mobile', threshold: 0.2 },
      { id: 'technologies', threshold: 0.2 },
      { id: 'aiar-success-story', threshold: 0.2 },
      { id: 'pricing', threshold: 0.2 },
      { id: 'contact', threshold: 0.2 },
    ];

    const observerCallback = (entries) => {
      // Debug log
      console.log('Intersecting sections:', entries.map(e => ({
        id: e.target.id,
        isIntersecting: e.isIntersecting,
        ratio: e.intersectionRatio
      })));

      // Check if we're at the top of the page
      if (window.scrollY < 100) {
        setActiveSection('');
        return;
      }

      entries.forEach(entry => {
        if (entry.isIntersecting) {
          setActiveSection(entry.target.id);
        }
      });
    };

    const observerOptions = {
      threshold: 0.1,
      rootMargin: '-10% 0px -50% 0px'
    };

    const observer = new IntersectionObserver(observerCallback, observerOptions);

    // Add scroll event listener to handle top of page
    const handleScroll = () => {
      if (window.scrollY < 100) {
        setActiveSection('');
      }
    };
    window.addEventListener('scroll', handleScroll);

    sections.forEach(section => {
      const element = document.getElementById(section.id);
      if (element) {
        observer.observe(element);
      }
    });

    return () => {
      observer.disconnect();
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <header className={`header-wrapper ${isScrolled ? 'scrolled' : ''} hidden lg:block`}>
      <div className="w-full px-4 md:px-6 lg:px-8">
        <div className="mx-auto max-w-[1400px]">
          <div className="rounded-full glass-effect px-4 md:px-6 lg:px-8 transition-all duration-300">
            <div className="logo-background"></div>
            <div className={`w-full flex justify-between items-center transition-all duration-300 ${isScrolled ? 'h-[60px]' : 'h-[75px]'}`}>
              {/* Logo section */}
              <div className={`flex items-center transition-all duration-300 ${isScrolled ? 'h-[41px] max-w-[285px]' : 'h-[51px] max-w-[355px]'}`}>
                <Link to="/" aria-label="logo" className="h-full w-full">
                  <img
                    src={logo}
                    alt="Informulate 20th Anniversary Logo"
                    className="h-full w-full object-contain transition-all duration-300"
                  />
                </Link>
              </div>

              {/* Navigation Links */}
              <div>
                <ul className="flex items-center space-x-4 md:space-x-6 lg:space-x-10">
                  <li className={`font-semibold transition-colors ${
                    activeSection === 'about' 
                    ? 'text-purple' 
                    : 'text-gray-700 hover:text-purple'
                  }`}>
                    <a href={`${hashPrefix}#about`}>About</a>
                  </li>
                  <li className={`font-semibold transition-colors ${
                    activeSection === 'service'
                    ? 'text-purple'
                    : 'text-gray-700 hover:text-purple'
                  }`}>
                    <a href={`${hashPrefix}#service`}>Services</a>
                  </li>
                  <li className={`font-semibold transition-colors ${
                    activeSection === 'technologies'
                    ? 'text-purple'
                    : 'text-gray-700 hover:text-purple'
                  }`}>
                    <a href={`${hashPrefix}#technologies`}>Technologies</a>
                  </li>
                  <li className={`font-semibold transition-colors ${
                    activeSection === 'testimonial'
                    ? 'text-purple'
                    : 'text-gray-700 hover:text-purple'
                  }`}>
                    <a href={`${hashPrefix}#testimonial`}>Testimonials</a>
                  </li>
                  <li className={`font-semibold transition-colors ${
                    activeSection === 'pricing'
                    ? 'text-purple'
                    : 'text-gray-700 hover:text-purple'
                  }`}>
                    <a href={`${hashPrefix}#pricing`}>Pricing</a>
                  </li>
                  {/* <li className={`font-semibold transition-colors ${
                    activeSection === 'contact' 
                    ? 'text-purple' 
                    : 'text-gray-700 hover:text-purple'
                  }`}>
                    <a href="#contact">Contact</a>
                  </li> */}
                </ul>
              </div>

              {/* CTA Button */}
            <div className="xl:flex hidden space-x-[30px] items-center">
              <a href={`${hashPrefix}#contact`}>
                  <div className={`px-6 rounded-full text-white bg-purple hover:bg-purple/90 transition-all duration-300 ${
                    isScrolled ? 'py-1' : 'py-2'
                  }`}>
                    <span className="text-white font-semibold">
                    Let's Talk
                  </span>
                </div>
              </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}
